import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ORDER_TYPES } from 'shared-modules/constants/manualTrade';
import { BUY_SELL_VALUE, CFD } from 'shared-modules/constants';
import { getServiceQuantityUnit, trimFrontZeros } from 'shared-modules/services';
import { useGetInstrumentDisplayName } from 'shared-modules/hooks';
import styles from './marketOrder.module.scss';

const MarketOrder = () => {
  const serviceId = useSelector((state) => state.auth.serviceId);
  const quantityUnit = getServiceQuantityUnit(serviceId);
  const instrumentId = useSelector((state) => state.manualTrade.selectedInstrumentId[serviceId]);
  const getInstrumentDisplayName = useGetInstrumentDisplayName();
  const isCrossOrder = useSelector((state) => state.settings[serviceId].isCrossOrder);
  const { quantityUnitConvFactor } = useSelector((state) => state.settings.instrumentList[instrumentId]);

  const buySell = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.MARKET_ORDER.name][ORDER_TYPES.MARKET_ORDER.inputs.BUY_SELL],
  );
  const count = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.MARKET_ORDER.name][ORDER_TYPES.MARKET_ORDER.inputs.COUNT],
  );

  const isCFD = useMemo(() => serviceId === CFD, [serviceId]);

  return (
    <>
      {isCrossOrder && <div className={styles.headerRow}>新規</div>}
      <div className={styles.brandRow}>
        銘柄
        <span>{getInstrumentDisplayName(instrumentId, serviceId)}</span>
      </div>
      <div className={styles.orderTypeRow}>
        注文条件
        <span>{isCrossOrder ? '成行' : '成行(FIFO)'}</span>
      </div>
      <div className={styles.buySellRow}>
        売買
        <span>{BUY_SELL_VALUE[buySell]}</span>
      </div>
      <div className={styles.countRow}>
        <div>
          数量
          {isCFD && <div>1Lot={quantityUnitConvFactor}</div>}
        </div>
        <span className={styles.boldText}>{`${trimFrontZeros(count)}${quantityUnit}`}</span>
      </div>
    </>
  );
};

export default memo(MarketOrder);
